// Remembers the purchase order the operator last worked with, shared across the
// Purchase Orders and Rolls Received screens. Lets Rolls Received pre-select the
// PO the operator was just working on (better shop-floor UX). Persists across
// navigation and reloads via localStorage; a missing/cleared value falls back to
// the most recent PO by DateOrdered at the call site.
const KEY = "mesf.rollshop.lastSelectedPurchaseOrderId";

export const getLastSelectedPurchaseOrderId = (): number | null => {
	try {
		const raw = localStorage.getItem(KEY);
		if (!raw) return null;
		const n = Number(raw);
		return Number.isFinite(n) ? n : null;
	} catch {
		return null;
	}
};

export const setLastSelectedPurchaseOrderId = (id: number | null): void => {
	try {
		if (id == null) localStorage.removeItem(KEY);
		else localStorage.setItem(KEY, String(id));
	} catch {
		// Ignore storage failures (private mode / disabled storage).
	}
};
